<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {nearDeposits} from 'src/components/cabinet/#services/nearAdapter'
    import {polygonDeposits} from 'src/components/cabinet/#services/evmAdapter'
    import {copyClipboard} from 'src/global/copyClipboard'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import successIcon from '@iconify/icons-fa-solid/check-circle'
    import pendingIcon from '@iconify/icons-fa-solid/spinner'
    import pauseIcon from '@iconify/icons-fa-solid/pause'
    import errorIcon from '@iconify/icons-fa-solid/exclamation-circle'
    import {roundNumber} from 'src/components/#common/helpers'
    import NearTransactions from 'src/components/cabinet/profile/components/deposits/NearTransactions.svelte'
    import PolygonTransactions from 'src/components/cabinet/profile/components/deposits/PolygonTransactions.svelte'

    export let userId

    let selectedNetwork = 'Near'

    async function copy(value) {
        copyClipboard(value)
    }
</script>
<div class="select-network">
    <label>Network:</label>
    <select class="form-select" bind:value={selectedNetwork}>
        <option>Near</option>
        <option>Polygon</option>
    </select>
</div>
<div class="transactions-list">
    {#if selectedNetwork === 'Near'}
        <NearTransactions userId={userId}/>
    {:else if selectedNetwork === 'Polygon'}
        <PolygonTransactions userId={userId}/>
    {/if}
</div>

<style>
    .select-network {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .select-network select {
        width: auto;
        margin-left: 10px;
    }

    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }
</style>
